import {
  REQUEST_CAMPAIGN_LIST,
  REQUEST_FILTERED_CAMPAIGN_LIST,
  REQUEST_CAMPAIGN,
} from './mutation-types';

import axiosInst from '@/utility/axiosInst';

export default {
  requestCampaignList({commit}, payload) {
    const {currentPage, currentCategorySeq, campaignType} = payload
    return axiosInst.springAxiosInst.get("/campaign/get-list", {
      params: {
        page: currentPage,
        categorySeq: currentCategorySeq,
      }
    }).then((res) => {
      commit(REQUEST_CAMPAIGN_LIST, res.data)
    })
  },

  requestCampaignList2({commit}, payload) {
    const {currentPage, currentCategorySeq, campaignType} = payload
    return axiosInst.springAxiosInst.get("/campaign/get-list2", {
      params: {
        page: currentPage,
        categorySeq: currentCategorySeq,
      }
    }).then((res) => {
      commit(REQUEST_CAMPAIGN_LIST, res.data)
    })
  },

  requestCampaignList1({commit}, payload) {
    const {currentPage, currentCategorySeq, campaignType} = payload
    return axiosInst.springAxiosInst.get("/campaign/get-list1", {
      params: {
        page: currentPage,
        categorySeq: currentCategorySeq,
      }
    }).then((res) => {
      commit(REQUEST_CAMPAIGN_LIST, res.data)
    })
  },

  requestFilteredCampaignList({commit}, payload) {
    const {
      categoryCampaignSeq = null,
      categoryDonationSeq = null,
      partnerSeq = null,
      sortDirection = 'ASC',
      limit = null,
      campaignType = null
    } = payload

    return axiosInst.springAxiosInst.get("/campaign/get-campaigns", {
      params: {
        categoryCampaignSeq,
        categoryDonationSeq,
        partnerSeq,
        sortDirection,
        limit,
        campaignType
      }
    }).then((res) => {
      commit(REQUEST_FILTERED_CAMPAIGN_LIST, res.data)
    }).catch((error) => {
        console.error("캠페인 목록 조회 실패:", error);
        return [];
    });
  },

  requestCampaign({commit}, campaignSeq) {
    return axiosInst.springAxiosInst.get("/campaign/get-detail", {
      params: {
        campaignSeq: campaignSeq
      }
    }).then((res) => {
      commit(REQUEST_CAMPAIGN, res.data)
    })
  }
}